import { Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
​
/**
 * Returns array of states similar to combineLatest or withLatestFrom
 * @param selectors Array of selectors
 */
export function multiSelect<T>(selectors: string[]) {
  return (o$: Observable<any>): Observable<T> => {
    return o$.pipe(
      map(state => {
        let result = [];
        selectors.forEach(s => result.push(state[s]))
        return ([...result] as unknown) as T;
      }),
      distinctUntilChanged((previous, current) => JSON.stringify(previous) === JSON.stringify(current))
    );
  };
}
